import Vue from 'vue'
import Router from 'vue-router'
import joinList from '@components/joinList'
import login from '@components/login'
import Cookies from 'js-cookie'
import articleList from '@components/pages/articleList'
import articleEdit from '@components/pages/articleEdit'
import origin from '@components/pages/origin'
import info from '@components/pages/info'
import remark from '@components/pages/remark'
import locationList from '@components/pages/locationList'
import locationEdit from '@components/pages/locationEdit'
import InformationSummaryList from '@components/pages/InformationSummaryList'

Vue.use(Router)

var routes = [
    {
        path: '/joinList',
        name: 'joinList',
        meta: {
            requireAuth: true,
        },
        component: joinList,
    },
    {
        path: '/',
        name: 'index',
        component: login,
        meta: {
            isHeaderHide: true,
            isNavHide: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: {
            isHeaderHide: true,
            isNavHide: true,
        }
    },
    {
        path: '/article/list',
        name: 'articleList',
        component: articleList,
    },
    {
        path: '/article/edit',
        name: 'articleEdit',
        component: articleEdit,
    },
    {
        path: '/origin',
        name: 'origin',
        component: origin,
    },
    {
        path: '/info',
        name: 'info',
        component: info,
    },
    {
        path: '/remark',
        name: 'remark',
        component: remark,
    },
    {
        path: '/location/list',
        name: 'locationList',
        component: locationList,
    },
    {
        path: '/location/edit',
        name: 'locationEdit',
        component: locationEdit,
    },
    {
        path: '/InformationSummary/list',
        name: 'InformationSummaryList',
        component: InformationSummaryList,
    },
]

const router = new Router({
    mode: 'history',
    routes,
    scollBehavior (to, from, savePosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 }
        }
    }
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    document.documentElement.scrollTop = 0;
    if (to.matched.length) {
        if (to.matched.some(r => r.meta.requireAuth)) {
            if (!Cookies.get('admin_token')) {
                next({
                    path: '/login',
                })
            } else {
                next()
            }
        } else {
            next()
        }
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js